var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interactive-manage"},[_c('el-breadcrumb',{staticClass:"interactive-breadcrumb",attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{staticClass:"first"},[_vm._v("工作台")]),_c('el-breadcrumb-item',{staticClass:"second"},[_vm._v("设置")])],1),_c('div',{staticClass:"editPwd"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }